/****************************************************
 * Module Name:  addFancyColorModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import FancyColorProxy from "../../utility/proxy/manager/fancyColorProxy";
import SaveIcon from '@mui/icons-material/Save';

export default class AddFancyColorModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newFancyColorDescription: this.props.editOperation ? this.props.sourceData.fancycolordescription : "",
            newShortName: this.props.editOperation ? this.props.sourceData.shortname : "",
            newFancyColor1: this.props.editOperation ? this.props.sourceData.fancycolor1 : "",
            newFancyColor2: this.props.editOperation ? this.props.sourceData.fancycolor2 : "",
            newFancyColorIntensity: this.props.editOperation ? this.props.sourceData.fancycolorintensity : "",
            newFancyColorOvertone: this.props.editOperation ? this.props.sourceData.fancycolorovertone : "",

            showError: false,
            validateFancyColorPresentSpinner: false,
            showValidationMessage: false,
            fancyColorAvailable: true,
            colorValidationError: "",
            fullNameValidationError: "",
        };
    }

    handleSave = () => {
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            fancycolordescription: this.state.newFancyColorDescription,
            shortname: this.state.newShortName,
            fancycolor1: this.state.newFancyColor1,
            fancycolor2: this.state.newFancyColor2,
            fancycolorintensity: this.state.newFancyColorIntensity,
            fancycolorovertone: this.state.newFancyColorOvertone,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data)) {
                    this.props.handleSave(data)
                } else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    validateColorPresent = (fancyColorEntered) => {
        if (!fancyColorEntered || fancyColorEntered.trim() === "") return;

        this.setState({
            validateFancyColorPresentSpinner: true,
        });

        FancyColorProxy.CheckFancyColorAvailable(fancyColorEntered, (response) => {
            //if we got response that means color is present at backend
            if (response) {
                //FancyColorName already present
                this.setState({
                    validateFancyColorPresentSpinner: false,
                    showValidationMessage: true,
                    fancyColorAvailable: true,
                });
            } else {
                //FancyColorName not available, so can be used
                this.setState({
                    validateFancyColorPresentSpinner: false,
                    showValidationMessage: true,
                    fancyColorAvailable: false,
                });
            }
        });
    };

    buttonDisable = () => {
        if (this.props.editOperation && this.state.newFancyColorDescription.length === 0)
            return true;

        if (!this.props.editOperation)
            return (
                !this.state.showValidationMessage ||
                !this.state.fancyColorAvailable ||
                this.state.newFancyColorDescription.length === 0
            );

        return false;
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add color validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <Modal backdrop="static" size="xl" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit Fancy Color" : "Add New Fancy Color"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>
                                                <Form.Label>Color Id</Form.Label>
                                            </td>
                                            <td>
                                                <Form.Label>{this.props.sourceData.id}</Form.Label>
                                            </td>
                                        </tr>
                                    )}
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Fancy Color Description <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        {this.props.editOperation ? (
                                            <td>
                                                <Form.Label>{this.state.newFancyColorDescription}</Form.Label>
                                            </td>
                                        ) : (
                                            <td>
                                                <TextField
                                                    margin="normal"
                                                    fullWidth
                                                    label="Fancy Color Description (required)"
                                                    placeholder="Enter Fancy Color"
                                                    value={this.state.newFancyColorDescription}
                                                    autoFocus
                                                    onBlur={(e) =>
                                                        this.validateColorPresent(this.state.newFancyColorDescription)
                                                    }
                                                    onChange={(e) => {
                                                        this.setState({
                                                            newFancyColorDescription: e.target.value,
                                                            showValidationMessage: false,
                                                            colorValidationError: Utility.CheckIsPresent(e.target.value) ? "" : "Fancy Color Description Cannot be Empty",
                                                        });
                                                    }}
                                                    helperText={this.state.colorValidationError}
                                                    error={this.state.colorValidationError.length > 0}
                                                />
                                            </td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            {this.state.validateFancyColorPresentSpinner ? (
                                                <CircularProgress size="1rem" />
                                            ) : !this.state.showValidationMessage ? (
                                                <Box>&nbsp;</Box>
                                            ) : this.state.fancyColorAvailable ? (
                                                <font color="green">Fancy Color available</font>
                                            ) : (
                                                <font color="red">Fancy Color not available</font>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Color Shortname</Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                required
                                                fullWidth
                                                label="Fancy Color Shortname"
                                                placeholder="Enter Fancy Color Shortname"
                                                value={this.state.newShortName}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newShortName: e.target.value,
                                                        fullNameValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Fancy Color Shortname Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.fullNameValidationError}
                                                error={this.state.fullNameValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Fancy Color 1</Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                label="Fancy Color 1"
                                                placeholder="Enter Fancy Color 1"
                                                value={this.state.newFancyColor1}
                                                onChange={(e) =>
                                                    this.setState({ newFancyColor1: e.target.value })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Fancy Color 2</Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                label="Fancy Color 2"
                                                placeholder="Enter Fancy Color 2"
                                                value={this.state.newFancyColor2}
                                                onChange={(e) =>
                                                    this.setState({ newFancyColor2: e.target.value })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Fancy Color Intensity</Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                label="Fancy Color Intensity"
                                                placeholder="Enter Fancy Color Intensity"
                                                value={this.state.newFancyColorIntensity}
                                                onChange={(e) =>
                                                    this.setState({ newFancyColorIntensity: e.target.value })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Fancy Color Overtone</Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                label="Fancy Color Overtone"
                                                placeholder="Enter Fancy Color Overtone"
                                                value={this.state.newFancyColorOvertone}
                                                onChange={(e) =>
                                                    this.setState({ newFancyColorOvertone: e.target.value })
                                                }
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
